import externalUrls from './externalUrls';

export const helpInfoItems = [
  {
    title: externalUrls.pages.helpInfo.support.title,
    items: [
      {
        text: externalUrls.pages.helpInfo.support.url.replace(/mailto:/, ''),
        link: externalUrls.pages.helpInfo.support.url
      }
    ]
  },
  {
    title: 'helpInfo.tabs.legal',
    items: [
      {
        text: 'helpInfo.whistleblower_system',
        link: '/whistleblower-system'
      },
      {
        text: externalUrls.pages.helpInfo.dataPrivacy.title,
        link: externalUrls.pages.helpInfo.dataPrivacy.url
      },
      {
        text: externalUrls.pages.helpInfo.imprint.title,
        link: externalUrls.pages.helpInfo.imprint.url
      }
    ]
  }
];
